<div class="map-location-container container" [ngClass]="{'full-container': options.layout === layoutDesign.V2}">
    <div class="px-0" *ngIf="(mapConfiguration.mainLocation !== null); else googleMapLoader">
        <div class="row">
            <div class="section-map-column"
                [ngClass]="{'col-md-8 layout-design-v2': options.layout === layoutDesign.V2}">
                <div [ngClass]="{'disabled-map': isMapDisabled}"></div>
                <cv-component-map [mapConfiguration]="mapConfiguration"
                    (newMarkerEmmiter)="onNewMarker($event)" [isPinSelectorMode]="isPinSelectorMode"
                    [isMapDisabled]="isMapDisabled">
                </cv-component-map>
            </div>
            <div class="section-map-column col-md-4" *ngIf="options.layout === layoutDesign.V2">
                <cv-schema-render-smart-tag-location
					[data]="data"
					[layoutNode]="layoutNode"
                    [mainPosition]="mapConfiguration.mainLocation.location"
					[smartTagLocation]="newMarker"
                    [pinSelectorMode]="isPinSelectorMode"
					(changePinSelectorMode)="changePinSelectorMode($event)"
                    (disableMap)="disableMap($event)"
					(newMarkerEmmiter)="onNewMarker($event)">
                </cv-schema-render-smart-tag-location>
            </div>
        </div>
    </div>
    <ng-template #googleMapLoader>
        <div class="map-location-loader">
            <div class="card skeleton">
                <div class="card-body">
                    <div class="card-img card-img-bottom loading">
                        <div class="loader-icon">
                            <i class="fas fa-map-marked-alt"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
</div>
